export default __webpack_public_path__ + "static/soehne-mono-web-buch-c109bc9e00bf397c954326c3ba0d3120.eot";